import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

export type AuthData = {
  token: string;
  user: {
    id: string;
    eduzzId: number;
    name: string;
    picture: string;
    email: string;
    document?: string;
    companyType?: string;
  };
};

type AuthStore = {
  authCompleted: boolean;
  authToken: string | null;
  currentUser: AuthData['user'] | null;
  setAuthData: (data: AuthData) => void;
  setAuthCompleted: () => void;
  updateUserName: (name: string) => void;
  isAuthenticated: () => boolean;
  logout: () => void;
};

export const authStore = create<AuthStore>()((set, get) => ({
  authCompleted: false,
  authToken: null,
  currentUser: null,

  setAuthData: ({ token, user }: AuthData) => {
    set({ authToken: token, currentUser: user });
  },

  setAuthCompleted: () => {
    set({ authCompleted: true });
  },

  updateUserName: (name: string) => {
    if (!name) {
      return;
    }

    const { currentUser } = get();

    if (currentUser) {
      set({ currentUser: { ...currentUser, name } });
    }
  },

  isAuthenticated: () => {
    const { authCompleted, authToken } = get();
    return authCompleted && Boolean(authToken);
  },

  logout: () => {
    set({ authToken: null, currentUser: null, authCompleted: false });
  }
}));

const useAuthStore = <T>(selector: (state: AuthStore) => T): T => {
  return authStore(useShallow(selector));
};

export default useAuthStore;
